import { IDoctor } from 'app/shared/model/doctor.model';
import { IMedicine } from 'app/shared/model/medicine.model';

export interface IDoctorRegularMedicine {
  id?: string;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  createdDtm?: number | null;
  createdBy?: string | null;
  doctor?: IDoctor | null;
  medicine?: IMedicine | null;
}

export const defaultValue: Readonly<IDoctorRegularMedicine> = {
  active: false,
};
